import { IconBox, IconProps } from 'src/lib/IconBox';
import React from 'react';

// eslint-disable-next-line import/no-default-export
export default (props: IconProps) => (
  <IconBox {...props}>
    <path d="M60.4676 0H3.53245C2.59558 0 1.69709 0.372167 1.03463 1.03463C0.372167 1.69709 0 2.59558 0 3.53245V60.4684C0.000235709 61.4052 0.372507 62.3034 1.03494 62.9657C1.69738 63.628 2.59574 64 3.53245 64H34.184V39.216H25.8436V29.5573H34.184V22.4338C34.184 14.1671 39.2329 9.66667 46.6071 9.66667C50.1396 9.66667 53.1751 9.92889 54.0604 10.0471V18.6862L48.9458 18.6889C44.9351 18.6889 44.1591 20.5947 44.1591 23.3911V29.5582H53.7236L52.4782 39.2169H44.1591V64H60.4684C61.4052 63.9998 62.3034 63.6275 62.9657 62.9651C63.628 62.3026 64 61.4043 64 60.4676V3.53245C64 2.59558 63.6278 1.69709 62.9654 1.03463C62.3029 0.372167 61.4044 0 60.4676 0Z" />
  </IconBox>
);
